import { Component } from '@angular/core';
import { CreatePasswordMode, CreatePasswordFormComponent } from '../../components/create-password-form/create-password-form.component';

@Component({
    selector: 'app-confirm-force-password-change',
    templateUrl: './confirm-force-password-change.component.html',
    styleUrls: ['./confirm-force-password-change.component.scss'],
    imports: [CreatePasswordFormComponent]
})
export class ConfirmForcePasswordChangeComponent {
  createPasswordModes = CreatePasswordMode;

  constructor() {}
}
